import { ButtonActionWithUi, ChangeMissionStartTime, MarkEventAsNotification, OneTimeEvent, SwitchMissionStatus, SwitchObjectState, SwitchState, SwitchStopStatus } from "../Actions";
import AddCommentView from "../Components/AddCommentView";
import { ButtonComponent } from "../Components/ButtonComponent";
import { MissionWorkflowComponent } from "../Components/MissionWorkflowComponent";
import { ObjectStateComponent } from "../Components/ObjectStateComponent";
import { StateComponent } from "../Components/StateComponent";
import { SettingsTypeToClassMapping } from "../Types";

export const mapping: SettingsTypeToClassMapping = {
    "MissionWorkflow": { clazz: MissionWorkflowComponent, createReactElement: true },
    "State": { clazz: StateComponent, createReactElement: true },
    "Button": { clazz: ButtonComponent, createReactElement: true },
    "SwitchState": { clazz: SwitchState },
    "ButtonActionWithUI": { clazz: ButtonActionWithUi },
    "MarkEventAsNotification": { clazz: MarkEventAsNotification },
    "SwitchObjectState": { clazz: SwitchObjectState },
    "SwitchMissionStatus": { clazz: SwitchMissionStatus },
    "ChangeMissionStartTime": { clazz: ChangeMissionStartTime },
    "ChangeMissionEndTime": { clazz: ChangeMissionStartTime }, //Not implemented
    "SwitchStopStatus": { clazz: SwitchStopStatus },
    "OneTimeEvent": { clazz: OneTimeEvent }, //Not implemented
    "AddObjectView": { clazz: OneTimeEvent }, //Not implemented
    "AddCommentView": { clazz: AddCommentView, createReactElement: true },
    "ModifyAddressView": { clazz: OneTimeEvent }, //Not implemented
    "ShowNextStops": { clazz: OneTimeEvent }, //Not implemented
    "AddressName": { clazz: OneTimeEvent }, //Not implemented
    "ExecuteButtonForAllObjects": { clazz: OneTimeEvent }, //Not implemented
    "FinishMission": { clazz: OneTimeEvent }, //Not implemented
    "ChangeMissionBasedOnObjects": { clazz: OneTimeEvent }, //Not implemented
    "ObjectState": { clazz: ObjectStateComponent, createReactElement: true },
    "ModifyObjectQuantityView": { clazz: ButtonActionWithUi }, //Not implemented
    "ShowObjectsWithStates": { clazz: StateComponent, createReactElement: true }, //Not implemented
    "StateId": { clazz: StateComponent, createReactElement: true }, //Not implemented

    "ChangeMissionColor": { clazz: OneTimeEvent}, //Not implemented
    "ChangeObjectStartTime": { clazz: OneTimeEvent}, //Not implemented
    "ChangeObjectEndTime": { clazz: OneTimeEvent}, //Not implemented
    "LockMissionStartTime": { clazz: OneTimeEvent}, //Not implemented
    "MissionAlertSettings": { clazz: OneTimeEvent}, //Not implemented
    "CreateHumanResourceMessage": { clazz: OneTimeEvent}, //Not implemented
    "OpenExternalAppView": { clazz: OneTimeEvent}, //Not implemented
    "OpenExternalAppParameterSettings": { clazz: OneTimeEvent}, //Not implemented
}
